import React from "react";

const SettingsSliderRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.19995 5.59998H4.79995",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 5.59998H12.8",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.19995 10.4H7.99995",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2 10.4H12.8",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.40005 7.2C7.2837 7.2 8.00005 6.48366 8.00005 5.6C8.00005 4.71634 7.2837 4 6.40005 4C5.51639 4 4.80005 4.71634 4.80005 5.6C4.80005 6.48366 5.51639 7.2 6.40005 7.2Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.6 12C10.4837 12 11.2 11.2837 11.2 10.4C11.2 9.51639 10.4837 8.80005 9.6 8.80005C8.71634 8.80005 8 9.51639 8 10.4C8 11.2837 8.71634 12 9.6 12Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SettingsSliderRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;